<template>
    <div class="question-tab">
      <p>How much Land?</p>
      <div class="checkbox-div">
        <div class="check">
          <input type="checkbox" />
          <p>0-2 Acres</p>
        </div>
        <div class="check">
          <input type="checkbox" />
          <p>2-5 Acres</p>
        </div>
        <div class="check">
            <input type="checkbox" />
            <p>2-5 Acres</p>
          </div>
          <div class="check">
            <input type="checkbox" />
            <p>2-5 Acres</p>
          </div>
      </div>
      
    </div>
  </template>
  <script>
  export default {
    name: "multipleAnswers",
    data() {
      return {};
    },
  };
  </script>
  <style lang="scss" scoped>
  .question-tab {
    display: flex;
    justify-content: space-between;
    margin-left: 28px;
    margin-top:28px;
    p {
      margin: 0;
    }
  }
  .checkbox-div {
    display: flex;
    align-items: center;
    width:40%;
    row-gap: 12px;
    column-gap: 32px;
    height:60px;
    flex-wrap: wrap;
    .check {
      display: flex;
      align-items: center;
      gap:12px;
      p{
          color:#4B4B4B
      }
    }
  }
  input[type="checkbox"] {
    accent-color: #189d3b;
    height: 16px;
    width: 16px;
    border-radius: 4px;
  }
  </style>
  